const widthAndHeightOptions = [
	{
		label: "Auto",
		value: "auto",
	},
	// {
	// 	label: "10%",
	// 	value: "s1",
	// },
	// {
	// 	label: "20%",
	// 	value: "s2",
	// },
	// {
	// 	label: "30%",
	// 	value: "s3",
	// },
	// {
	// 	label: "40%",
	// 	value: "s4",
	// },
	// {
	// 	label: "50%",
	// 	value: "s5",
	// },
	// {
	// 	label: "60%",
	// 	value: "s6",
	// },
	// {
	// 	label: "70%",
	// 	value: "s7",
	// },
	// {
	// 	label: "80%",
	// 	value: "s8",
	// },
	// {
	// 	label: "90%",
	// 	value: "s9",
	// },
	{
		label: "100%",
		value: "s10",
	},
];
const widthAndHeightScreenOptions = [
	{
		label: "Auto",
		value: "auto",
	},
	{
		label: "10%",
		value: "s1",
	},
	{
		label: "20%",
		value: "s2",
	},
	{
		label: "30%",
		value: "s3",
	},
	{
		label: "40%",
		value: "s4",
	},
	{
		label: "50%",
		value: "s5",
	},
	{
		label: "60%",
		value: "s6",
	},
	{
		label: "70%",
		value: "s7",
	},
	{
		label: "80%",
		value: "s8",
	},
	{
		label: "90%",
		value: "s9",
	},
	{
		label: "100%",
		value: "s10",
	},
];

const fontSizeOptions = [
	{
		label: "Extra small",
		value: "sxs",
	},
	{
		label: "Small",
		value: "ssm",
	},
	{
		label: "Medium",
		value: "sbase",
	},
	{
		label: "Large",
		value: "slg",
	},
	{
		label: "XL",
		value: "sxl",
	},
	{
		label: "2XL",
		value: "s2xl",
	},
	{
		label: "3XL",
		value: "s3xl",
	},
	{
		label: "4XL",
		value: "s4xl",
	},
	{
		label: "5XL",
		value: "s5xl",
	},
	{
		label: "6XL",
		value: "s6xl",
	},
	{
		label: "7XL",
		value: "s7xl",
	},
	{
		label: "8XL",
		value: "s8xl",
	},
	{
		label: "9XL",
		value: "s9xl",
	},
	{
		label: "10XL",
		value: "s10xl",
	},
	{
		label: "11XL",
		value: "s11xl",
	},
	{
		label: "12XL",
		value: "s12xl",
	},
	{
		label: "13XL",
		value: "s13xl",
	},
	{
		label: "14XL",
		value: "s14xl",
	},
	{
		label: "15XL",
		value: "s15xl",
	},
];

const leadingOptions = [
	{
		label: "Auto",
		value: "unset",
	},
	{
		label: "0",
		value: "s0",
	},
	{
		label: "1",
		value: "s1",
	},
	{
		label: "2",
		value: "s2",
	},
	{
		label: "3",
		value: "s3",
	},
	{
		label: "4",
		value: "s4",
	},
	{
		label: "5",
		value: "s5",
	},
	{
		label: "6",
		value: "s6",
	},
	{
		label: "7",
		value: "s7",
	},
	{
		label: "8",
		value: "s8",
	},
	{
		label: "9",
		value: "s9",
	},
	{
		label: "10",
		value: "s10",
	},
	{
		label: "11",
		value: "s11",
	},
	{
		label: "12",
		value: "s12",
	},
	{
		label: "13",
		value: "s13",
	},
	{
		label: "14",
		value: "s14",
	},
	{
		label: "15",
		value: "s15",
	},
];

const justifyOptions = [
	{
		label: "Left",
		value: "start",
	},
	{
		label: "Center",
		value: "center",
	},
	{
		label: "Right",
		value: "end",
	},
];

const itemsOptions = [
	{
		label: "Top",
		value: "start",
	},
	{
		label: "Center",
		value: "center",
	},
	{
		label: "Bottom",
		value: "end",
	},
];

const textAlignOptions = [
	{
		label: "Left",
		value: "left",
	},
	{
		label: "Center",
		value: "center",
	},
	{
		label: "Right",
		value: "right",
	},
];

const paddingOptions = [
	{
		label: 0,
		value: "s0",
	},
	{
		label: 1,
		value: "s1",
	},
	{
		label: 2,
		value: "s2",
	},
	{
		label: 3,
		value: "s3",
	},
	{
		label: 4,
		value: "s4",
	},
	{
		label: 5,
		value: "s5",
	},
	{
		label: 6,
		value: "s6",
	},
	{
		label: 7,
		value: "s7",
	},
	{
		label: 8,
		value: "s8",
	},
	{
		label: 9,
		value: "s9",
	},
	{
		label: 10,
		value: "s10",
	},
	{
		label: 11,
		value: "s11",
	},
	{
		label: 12,
		value: "s12",
	},
	{
		label: 13,
		value: "s13",
	},
	{
		label: 14,
		value: "s14",
	},
	{
		label: 15,
		value: "s15",
	},
	{
		label: 16,
		value: "s16",
	},
	{
		label: 17,
		value: "s17",
	},
	{
		label: 18,
		value: "s18",
	},
	{
		label: 19,
		value: "s19",
	},
	{
		label: 20,
		value: "s20",
	},
	{
		label: 21,
		value: "s21",
	},
	{
		label: 22,
		value: "s22",
	},
	{
		label: 23,
		value: "s23",
	},
	{
		label: 24,
		value: "s24",
	},
	{
		label: 25,
		value: "s25",
	},
	//  {
	//   label: 26,
	//   value: "s26",
	//  },
	//  {
	//   label: 27,
	//   value: "s27",
	//  },
	//  {
	//   label: 28,
	//   value: "s28",
	//  },
	//  {
	//   label: 29,
	//   value: "s29",
	//  },
	//  {
	//   label: 30,
	//   value: "s30",
	//  },
	//  {
	//   label: 31,
	//   value: "s31",
	//  },
	//  {
	//   label: 32,
	//   value: "s32",
	//  },
	//  {
	//   label: 33,
	//   value: "s33",
	//  },
	//  {
	//   label: 34,
	//   value: "s34",
	//  },
	//  {
	//   label: 35,
	//   value: "s35",
	//  },
	//  {
	//   label: 36,
	//   value: "s36",
	//  },
	//  {
	//   label: 37,
	//   value: "s37",
	//  },
	//  {
	//   label: 38,
	//   value: "s38",
	//  },
	//  {
	//   label: 39,
	//   value: "s39",
	//  },
	//  {
	//   label: 40,
	//   value: "s40",
	//  },
	//  {
	//   label: 41,
	//   value: "s41",
	//  },
	//  {
	//   label: 42,
	//   value: "s42",
	//  },
	//  {
	//   label: 43,
	//   value: "s43",
	//  },
	//  {
	//   label: 44,
	//   value: "s44",
	//  },
	//  {
	//   label: 45,
	//   value: "s45",
	//  },
	//  {
	//   label: 46,
	//   value: "s46",
	//  },
	//  {
	//   label: 47,
	//   value: "s47",
	//  },
	//  {
	//   label: 48,
	//   value: "s48",
	//  },
	//  {
	//   label: 49,
	//   value: "s49",
	//  },
	//  {
	//   label: 50,
	//   value: "s50",
	//  },
	//  {
	//   label: 51,
	//   value: "s51",
	//  },
	//  {
	//   label: 52,
	//   value: "s52",
	//  },
	//  {
	//   label: 53,
	//   value: "s53",
	//  },
	//  {
	//   label: 54,
	//   value: "s54",
	//  },
	//  {
	//   label: 55,
	//   value: "s55",
	//  },
	//  {
	//   label: 56,
	//   value: "s56",
	//  },
	//  {
	//   label: 57,
	//   value: "s57",
	//  },
	//  {
	//   label: 58,
	//   value: "s58",
	//  },
	//  {
	//   label: 59,
	//   value: "s59",
	//  },
	//  {
	//   label: 60,
	//   value: "s60",
	//  },
	//  {
	//   label: 61,
	//   value: "s61",
	//  },
	//  {
	//   label: 62,
	//   value: "s62",
	//  },
	//  {
	//   label: 63,
	//   value: "s63",
	//  },
	//  {
	//   label: 64,
	//   value: "s64",
	//  },
	//  {
	//   label: 65,
	//   value: "s65",
	//  },
	//  {
	//   label: 66,
	//   value: "s66",
	//  },
	//  {
	//   label: 67,
	//   value: "s67",
	//  },
	//  {
	//   label: 68,
	//   value: "s68",
	//  },
	//  {
	//   label: 69,
	//   value: "s69",
	//  },
	//  {
	//   label: 70,
	//   value: "s70",
	//  },
	//  {
	//   label: 71,
	//   value: "s71",
	//  },
	//  {
	//   label: 72,
	//   value: "s72",
	//  },
	//  {
	//   label: 73,
	//   value: "s73",
	//  },
	//  {
	//   label: 74,
	//   value: "s74",
	//  },
	//  {
	//   label: 75,
	//   value: "s75",
	//  },
	//  {
	//   label: 76,
	//   value: "s76",
	//  },
	//  {
	//   label: 77,
	//   value: "s77",
	//  },
	//  {
	//   label: 78,
	//   value: "s78",
	//  },
	//  {
	//   label: 79,
	//   value: "s79",
	//  },
	//  {
	//   label: 80,
	//   value: "s80",
	//  },
	//  {
	//   label: 81,
	//   value: "s81",
	//  },
	//  {
	//   label: 82,
	//   value: "s82",
	//  },
	//  {
	//   label: 83,
	//   value: "s83",
	//  },
	//  {
	//   label: 84,
	//   value: "s84",
	//  },
	//  {
	//   label: 85,
	//   value: "s85",
	//  },
	//  {
	//   label: 86,
	//   value: "s86",
	//  },
	//  {
	//   label: 87,
	//   value: "s87",
	//  },
	//  {
	//   label: 88,
	//   value: "s88",
	//  },
	//  {
	//   label: 89,
	//   value: "s89",
	//  },
	//  {
	//   label: 90,
	//   value: "s90",
	//  },
	//  {
	//   label: 91,
	//   value: "s91",
	//  },
	//  {
	//   label: 92,
	//   value: "s92",
	//  },
	//  {
	//   label: 93,
	//   value: "s93",
	//  },
	//  {
	//   label: 94,
	//   value: "s94",
	//  },
	//  {
	//   label: 95,
	//   value: "s95",
	//  },
	//  {
	//   label: 96,
	//   value: "s96",
	//  },
	//  {
	//   label: 97,
	//   value: "s97",
	//  },
	//  {
	//   label: 98,
	//   value: "s98",
	//  },
	//  {
	//   label: 99,
	//   value: "s99",
	//  },
	//  {
	//   label: 100,
	//   value: "s100",
	//  },
];

const marginOptions = [
	{
		label: 0,
		value: "s0",
	},
	{
		label: 1,
		value: "s1",
	},
	{
		label: 2,
		value: "s2",
	},
	{
		label: 3,
		value: "s3",
	},
	{
		label: 4,
		value: "s4",
	},
	{
		label: 5,
		value: "s5",
	},
	{
		label: 6,
		value: "s6",
	},
	{
		label: 7,
		value: "s7",
	},
	{
		label: 8,
		value: "s8",
	},
	{
		label: 9,
		value: "s9",
	},
	{
		label: 10,
		value: "s10",
	},
	{
		label: 11,
		value: "s11",
	},
	{
		label: 12,
		value: "s12",
	},
	{
		label: 13,
		value: "s13",
	},
	{
		label: 14,
		value: "s14",
	},
	{
		label: 15,
		value: "s15",
	},
	{
		label: 16,
		value: "s16",
	},
	{
		label: 17,
		value: "s17",
	},
	{
		label: 18,
		value: "s18",
	},
	{
		label: 19,
		value: "s19",
	},
	{
		label: 20,
		value: "s20",
	},
	{
		label: 21,
		value: "s21",
	},
	{
		label: 22,
		value: "s22",
	},
	{
		label: 23,
		value: "s23",
	},
	{
		label: 24,
		value: "s24",
	},
	{
		label: 25,
		value: "s25",
	},
	{
		label: 26,
		value: "s26",
	},
	{
		label: 27,
		value: "s27",
	},
	{
		label: 28,
		value: "s28",
	},
	{
		label: 29,
		value: "s29",
	},
	{
		label: 30,
		value: "s30",
	},
	{
		label: 31,
		value: "s31",
	},
	{
		label: 32,
		value: "s32",
	},
	{
		label: 33,
		value: "s33",
	},
	{
		label: 34,
		value: "s34",
	},
	{
		label: 35,
		value: "s35",
	},
	{
		label: 36,
		value: "s36",
	},
	{
		label: 37,
		value: "s37",
	},
	{
		label: 38,
		value: "s38",
	},
	{
		label: 39,
		value: "s39",
	},
	{
		label: 40,
		value: "s40",
	},
	{
		label: 41,
		value: "s41",
	},
	{
		label: 42,
		value: "s42",
	},
	{
		label: 43,
		value: "s43",
	},
	{
		label: 44,
		value: "s44",
	},
	{
		label: 45,
		value: "s45",
	},
	{
		label: 46,
		value: "s46",
	},
	{
		label: 47,
		value: "s47",
	},
	{
		label: 48,
		value: "s48",
	},
	{
		label: 49,
		value: "s49",
	},
	{
		label: 50,
		value: "s50",
	},
	//  {
	//   label: 51,
	//   value: "s51",
	//  },
	//  {
	//   label: 52,
	//   value: "s52",
	//  },
	//  {
	//   label: 53,
	//   value: "s53",
	//  },
	//  {
	//   label: 54,
	//   value: "s54",
	//  },
	//  {
	//   label: 55,
	//   value: "s55",
	//  },
	//  {
	//   label: 56,
	//   value: "s56",
	//  },
	//  {
	//   label: 57,
	//   value: "s57",
	//  },
	//  {
	//   label: 58,
	//   value: "s58",
	//  },
	//  {
	//   label: 59,
	//   value: "s59",
	//  },
	//  {
	//   label: 60,
	//   value: "s60",
	//  },
	//  {
	//   label: 61,
	//   value: "s61",
	//  },
	//  {
	//   label: 62,
	//   value: "s62",
	//  },
	//  {
	//   label: 63,
	//   value: "s63",
	//  },
	//  {
	//   label: 64,
	//   value: "s64",
	//  },
	//  {
	//   label: 65,
	//   value: "s65",
	//  },
	//  {
	//   label: 66,
	//   value: "s66",
	//  },
	//  {
	//   label: 67,
	//   value: "s67",
	//  },
	//  {
	//   label: 68,
	//   value: "s68",
	//  },
	//  {
	//   label: 69,
	//   value: "s69",
	//  },
	//  {
	//   label: 70,
	//   value: "s70",
	//  },
	//  {
	//   label: 71,
	//   value: "s71",
	//  },
	//  {
	//   label: 72,
	//   value: "s72",
	//  },
	//  {
	//   label: 73,
	//   value: "s73",
	//  },
	//  {
	//   label: 74,
	//   value: "s74",
	//  },
	//  {
	//   label: 75,
	//   value: "s75",
	//  },
	//  {
	//   label: 76,
	//   value: "s76",
	//  },
	//  {
	//   label: 77,
	//   value: "s77",
	//  },
	//  {
	//   label: 78,
	//   value: "s78",
	//  },
	//  {
	//   label: 79,
	//   value: "s79",
	//  },
	//  {
	//   label: 80,
	//   value: "s80",
	//  },
	//  {
	//   label: 81,
	//   value: "s81",
	//  },
	//  {
	//   label: 82,
	//   value: "s82",
	//  },
	//  {
	//   label: 83,
	//   value: "s83",
	//  },
	//  {
	//   label: 84,
	//   value: "s84",
	//  },
	//  {
	//   label: 85,
	//   value: "s85",
	//  },
	//  {
	//   label: 86,
	//   value: "s86",
	//  },
	//  {
	//   label: 87,
	//   value: "s87",
	//  },
	//  {
	//   label: 88,
	//   value: "s88",
	//  },
	//  {
	//   label: 89,
	//   value: "s89",
	//  },
	//  {
	//   label: 90,
	//   value: "s90",
	//  },
	//  {
	//   label: 91,
	//   value: "s91",
	//  },
	//  {
	//   label: 92,
	//   value: "s92",
	//  },
	//  {
	//   label: 93,
	//   value: "s93",
	//  },
	//  {
	//   label: 94,
	//   value: "s94",
	//  },
	//  {
	//   label: 95,
	//   value: "s95",
	//  },
	//  {
	//   label: 96,
	//   value: "s96",
	//  },
	//  {
	//   label: 97,
	//   value: "s97",
	//  },
	//  {
	//   label: 98,
	//   value: "s98",
	//  },
	//  {
	//   label: 99,
	//   value: "s99",
	//  },
	//  {
	//   label: 100,
	//   value: "s100",
	//  },
];

const transitionOptions = [
	{
		label: "None",
		value: "none",
	},
	{
		label: "Fade",
		value: "fade",
	},
	{
		label: "Slide",
		value: "slide",
	},
	{
		label: "Slide & Fade",
		value: "slide_fade",
	},
	{
		label: "Scale",
		value: "scale",
	},
	{
		label: "Scale & Fade",
		value: "scale_fade",
	},
	{
		label: "Blur & Fade",
		value: "blur_fade",
	},
	//  {
	//   label: "Slide from Top",
	//   value: "slide_from_top",
	//  },
	//  {
	//   label: "Slide from Bottom",
	//   value: "slide_from_bottom",
	//  },
	//  {
	//   label: "Slide from Left",
	//   value: "slide_from_left",
	//  },
	//  {
	//   label: "Slide from Right",
	//   value: "slide_from_right",
	//  },
	//  {
	//   label: "Wipe Top and Bottom",
	//   value: "wipe_top_bottom",
	//  },
	//  {
	//   label: "Wipe Left and Right",
	//   value: "wipe_left_right",
	//  },
	//  {
	//   label: "Wipe Top",
	//   value: "wipe_top",
	//  },
	//  {
	//   label: "Wipe Bottom",
	//   value: "wipe_bottom",
	//  },
	//  {
	//   label: "Wipe Left",
	//   value: "wipe_left",
	//  },
	//  {
	//   label: "Wipe Right",
	//   value: "wipe_right",
	//  },
];

const transitionDurationOptions = [
	{
		label: "0.5 seconds",
		value: "500",
	},
	{
		label: "1 second",
		value: "1000",
	},
	{
		label: "2 seconds",
		value: "2000",
	},
	{
		label: "3 seconds",
		value: "3000",
	},
	{
		label: "4 seconds",
		value: "4000",
	},
	{
		label: "5 seconds",
		value: "5000",
	},
];

const backgroundSizeOptions = [
	{
		label: "Grow to fill screen",
		value: "cover",
	},
	{
		label: "Shrink to fit",
		value: "contain",
	},
];

const roundedOptions = [
	{
		label: "None",
		value: "snone",
	},
	{
		label: "Extra Small",
		value: "sxs",
	},
	{
		label: "Small",
		value: "ssm",
	},
	{
		label: "Medium",
		value: "sbase",
	},
	{
		label: "Large",
		value: "smd",
	},
	{
		label: "XL",
		value: "slg",
	},
	{
		label: "2XL",
		value: "sxl",
	},
	//  {
	//   label: "Full",
	//   value: "sfull",
	//  },
];

const borderSizeOptions = [
	{
		label: "0",
		value: "0",
	},
	{
		label: "1",
		value: ".1",
	},
	{
		label: "2",
		value: ".2",
	},
	{
		label: "3",
		value: ".3",
	},
	{
		label: "4",
		value: ".4",
	},
	{
		label: "5",
		value: ".5",
	},
	{
		label: "6",
		value: ".6",
	},
	{
		label: "7",
		value: ".7",
	},
	{
		label: "8",
		value: ".8",
	},
	{
		label: "9",
		value: ".9",
	},
	{
		label: "10",
		value: "1",
	},
];

const thicknessOptions = [
	{
		label: "0",
		value: "0",
	},
	{
		label: "0.5",
		value: "0.5",
	},
	{
		label: "1",
		value: "1",
	},
	{
		label: "2",
		value: "2",
	},
	{
		label: "3",
		value: "3",
	},
	{
		label: "4",
		value: "4",
	},
	{
		label: "5",
		value: "5",
	},
	{
		label: "6",
		value: "6",
	},
	{
		label: "7",
		value: "7",
	},
	{
		label: "8",
		value: "8",
	},
	{
		label: "9",
		value: "9",
	},
	{
		label: "10",
		value: "10",
	},
];

const borderOptions = [
	{
		label: "Dashed",
		value: "dashed",
	},
	{
		label: "Dotted",
		value: "dotted",
	},
	{
		label: "Double",
		value: "double",
	},
	{
		label: "Solid",
		value: "solid",
	},
];

const gradientOptions = [
	{
		label: "None",
		value: "false",
	},
	{
		label: "→ Right",
		value: "90",
	},
	{
		label: "← Left",
		value: "270",
	},
	{
		label: "↓ Down",
		value: "180",
	},
	{
		label: "↑ Up",
		value: "0",
	},
];

const definitions = {
	font: {
		label: "Font",
		family: {
			label: "Family",
			type: "input",
		},
	},
	h1: {
		label: "Large text",
		colour: {
			label: "Colour",
			type: "input",
		},
		size: {
			type: "range",
			label: "Size",
			options: fontSizeOptions,
		},
	},
	h2: {
		label: "Small text",
		colour: {
			label: "Colour",
			type: "input",
		},
		size: {
			type: "range",
			label: "Size",
			options: fontSizeOptions,
		},
	},
	background: {
		label: "Background",
		colour: {
			label: "Colour",
			type: "input",
		},
		// gradient: {
		// 	label: "Gradient",
		// 	type: "toggle",
		// },
		// degrees: {
		// 	label: "Direction",
		// 	type: "input",
		// },
		// colour2: {
		// 	label: "Colour 2",
		// 	type: "input",
		// },
		paddingX: {
			type: "range",
			label: "Padding Left/Right",
			options: paddingOptions,
		},
		paddingY: {
			type: "range",
			label: "Padding Top/Bottom",
			options: paddingOptions,
		},
		width: {
			type: "range",
			label: "Width",
			options: widthAndHeightOptions,
		},
		height: {
			type: "range",
			label: "Height",
			options: widthAndHeightOptions,
		},
		rounding: {
			type: "range",
			label: "Rounding",
			options: roundedOptions,
		},
	},
	border: {
		label: "Border",
		sides: {
			label: "Sides",
			type: "border",
		},
		// left: {
		// 	type: "toggle",
		// },
		// right: {
		// 	type: "toggle",
		// },
		// top: {
		// 	type: "toggle",
		// },
		// bottom: {
		// 	type: "toggle",
		// },
		// size: {
		// 	type: "toggle",
		// },
		style: {
			label: "Style",
			type: "select",
			options: borderOptions,
		},
		colour: {
			label: "Colour",
			type: "input",
		},
	},
	position: {
		label: "Position",
		x: {
			type: "select",
			label: "Horizontal",
			options: justifyOptions,
		},
		y: {
			type: "select",
			label: "Vertical",
			options: itemsOptions,
		},
		marginX: {
			type: "range",
			label: "Margin Left/Right",
			options: marginOptions,
		},
		marginY: {
			type: "range",
			label: "Margin Top/Bottom",
			options: marginOptions,
		},
		textAlign: {
			type: "select",
			label: "Text Align",
			options: textAlignOptions,
		},
		fit: {
			type: "select",
			label: "Image fit",
			options: backgroundSizeOptions,
		},
	},
	transition: {
		label: "Transition",
		type: {
			type: "select",
			label: "Type",
			options: transitionOptions,
		},
		// duration: {
		// 	type: "input",
		// },
		// ease: {
		// 	type: "select",
		// },
	},
};

const transformOrigins = {
	tl: "top left",
	tc: "top center",
	tr: "top right",
	ml: "center left",
	mc: "center",
	mr: "center right",
	bl: "bottom left",
	bc: "bottom center",
	br: "bottom right",
};

module.exports = {
	widthAndHeightOptions,
	widthAndHeightScreenOptions,
	fontSizeOptions,
	leadingOptions,
	justifyOptions,
	itemsOptions,
	textAlignOptions,
	paddingOptions,
	marginOptions,
	transitionOptions,
	transitionDurationOptions,
	backgroundSizeOptions,
	roundedOptions,
	borderOptions,
	borderSizeOptions,
	definitions,
	transformOrigins,
	thicknessOptions,
	gradientOptions,
};
